export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/catalog_design.1ffac26.svg";